import styled from 'styled-components'

export const InfoSec = styled.section`
  background: #001d07;
  padding: clamp(14px, 2.5vw, 22px) 0;
  border-top: 1px solid rgba(161, 255, 113, 0.15);
  border-bottom: 1px solid rgba(161, 255, 113, 0.15);
`

export const InfoRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  justify-items: center;
  align-items: center;
  gap: clamp(10px, 4vw, 60px);
  max-width: 900px;
  margin: 0 auto;
`

export const InfoImg = styled.img`
  width: 100%;
  max-width: 200px;
  height: auto;
  max-height: 80px;
  object-fit: contain;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }
`
